import { useQuery } from '@apollo/client';
import { GET_PROCESS_AREAS_IT_APPLICATION_REPORT } from '../graphql';
import type {
  CyberHubItApplicationSummariesEnum,
  GetCyberHubItApplicationSummaryData,
  GetCyberHubItApplicationSummaryVars,
} from '../types/reports';

/**
 * Hook to fetch process areas summary
 * @param locationUUID - The UUID of the location to fetch the data for. If not provided, the data will be fetched for enterprise level.
 * @returns {{ data: GetCyberHubItApplicationSummaryData<CyberHubItApplicationSummariesEnum.PROCESS_AREAS>[], loading: boolean, error: ApolloError }}
 */
export const useProcessAreasItApplicationSummary = (
  locationUUID?: string,
) => {
  if (!locationUUID) {
    console.error(
      'useProcessAreasItApplicationSummary GraphQL error:',
      'Location UUID is required',
    );
  }

  const result = useQuery<
    GetCyberHubItApplicationSummaryData<CyberHubItApplicationSummariesEnum.PROCESS_AREAS>,
    GetCyberHubItApplicationSummaryVars
  >(GET_PROCESS_AREAS_IT_APPLICATION_REPORT, {
    variables: { locationUUID },
  });

  // Debug logging
  if (result.error) {
    console.error(
      'useProcessAreasItApplicationSummary GraphQL error:',
      result.error,
    );
  }

  return {
    data: result.data?.getProcessAreasItApplicationSummary,
    loading: result.loading,
    error: result.error,
  };
};
